import { notifyMutationError } from '@inquiries/-lib/handleInquiryCompletedError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { createInquiryCoordination } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

export function useCreateInquiryCoordination(inquiryId: number) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ memberId, content }: { memberId: number; content: string }) => {
      return createInquiryCoordination(inquiryId, { memberId, content })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.inquiry.coordinations(inquiryId) })
      queryClient.invalidateQueries({ queryKey: queryKeys.inquiry.actionLogs(inquiryId) })
      toast.success('調整状況を作成しました')
    },
    onError: (error: Error) => {
      notifyMutationError(error, '調整状況の作成に失敗しました')
    },
  })
}
